import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Layout from '../../components/Layout/Layout';
import { DefaultButton, SubTitleH2 } from '../../components';

const Test = () => (
  <Layout>
    <Container fluid>
      <Row>
        <Col role="main">
          <div className="section">
            <SubTitleH2 text="Evaluaciones" />
            <Row style={{ borderBottom: '3px', borderColor: 'red' }}>
              <Col>
                <DefaultButton name="Crear Evaluación" />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  </Layout>
);

export default Test;
